import React from 'react';
import Content from './Components/Content'

function App() {
  return (
    <div className="App">
      <h1 className="einstein-title"> Einstein </h1>
      <p className="einstein-text"> An open source math problem solver for algebra, trigonometry, calculus and <br/> other advance mathematics using newton api </p>
      <Content />
      <p className="einstein-text einstein-text--16"> 
        Note: To find the <span> tangent line of a function </span> at a certain x value, write the equation as c
        |f(x) where c: given x value and f(x): function expression, the separator: a vertical bar '|'. See sample equation: <span>  2|x^3 </span>
      </p>
      <p className="einstein-text einstein-text--16"> 
        <span> Area under a function </span> : write the equation as c:d|f(x) where c is the starting x value, 
        d is the ending x value, and f(x) is the function under which you want the curve between the two x values.
      </p>
      <p className="einstein-text einstein-text--16"> 
      <span> Fractions </span> : enter expressions as numerator(over)denominator. Example: write <span> 2(over)4 </span> to process <span> 2/4 </span>.
      </p>
      <footer>
        <p className="einstein-text einstein-text--footer"> Designed and Developed by Paolo Ligsay </p>
      </footer>
      <div className="einstein-background-svg"></div>
    </div>
  )
}

export default App;
